export const environment = {
    'backendBaseUrl': 'https://tardis-apim.staging.app.inh.re/mass-eligibility',
    'fibreBuildingApiBaseUrl': 'https://tardis-apim.staging.app.inh.re/fibre-building-api',
    'keycloakBaseUrl': 'https://sso.inherent.fr/',
    'keycloakRealm': 'pf-business-test',
    'keycloakClientId': '438d5dc5-d30f-42d3-8607-23216d251fc5',
    'stompWebsocketUrl': 'wss://mass-eligibility-rmq.staging.app.inh.re/ws',
    'stompWebsocketUsername': 'mass-eligibility-front',
    'stompWebsocketPassword': 'babec5e35fc58286306c38155edce1a18d5ed639',
    'stompWebsocketHost': 'mass-eligibility'
};
